<template>
  <div>    
    <b-card v-if="renderizar && controleTela.valor == controleTela.EXIBIR_PASSOS">
      <EmitirGuiaPasso1
        @carregarPasso="carregarPasso1"
        @novaEmissao="novaEmissao"
        :disabled="disabledConsultaInicial"
        :habilitaNovaConsulta="habilitaNovaConsulta"
        :carregandoRoot="carregando"
        ref="passoInicial"
      />
    <b-overlay :show="carregando" opacity="0.50" spinner-type="none">
        <div v-for="(passo, indicePassos) in passos" :key="indicePassos">
          <b-card :id="`card_${indicePassos}`" v-if="Object.keys(passo.data).length">
          <div slot="header">Etapa {{indicePassos+1}} de {{controlePassos.totalPassos}}</div>
          <b-alert v-if="exibirMensagemIPVA && indicePassos == 0" show variant="info" class="m-3">
            Informamos que no dia 31 de dezembro (quarta-feira) a partir das 0h00min, haverá indisponibilidade em alguns serviços tendo em vista a necessidade de manutenção programada pelo Detran/PR e SEFA, com previsão de retorno para o dia 1ª de janeiro (quinta-feira) às 15h00.
          </b-alert>
          <b-row sm="12" md="12">
            <b-col sm="12" :md="calculaLargura(passo.data.lstCampos, idx)" v-for="(campo, idx) in passo.data.lstCampos" :key="campo.idParametCampoGuia">
                <InputTipoDado
                  :larguraColuna="calculaLarguraInterna(passo.data.lstCampos, idx)"
                  v-if="campo.passo == indicePassos + 1"
                  :id="`id_${indicePassos}_${idx}`"
                  :idx="idx"
                  :indicePassos="indicePassos"
                  :passos="passos"
                  :campo="campo"
                  :passo="passo"
                  :lstCampos="passo.data.lstCampos"
                  @situacaoInexistente="situacaoInexistente"
                  @redirecionamento="abrirRedirecionamento"
                  :v="$v"
                />
            </b-col>
          </b-row>
          <div>            
            <div v-if="(indicePassos + 1) != (controlePassos.totalPassos)" class="center-xy pt-4">
                <b-button :disabled="passo.disabled || isPassoDesabilitado" class="mr-1" variant="primary"  @click="avancar(passo, indicePassos)"
                  ><i class="fas fa-arrow-right"></i>Avançar</b-button>
                <b-button class="mr-1" variant="secondary"  @click="limparPasso(passo, indicePassos)"
                  ><i class="fas fa-eraser"></i>Limpar</b-button>
            </div>            
            <div v-else class="center-xy pt-4">              
                <b-button :disabled="passo.disabled || isPassoDesabilitado" class="mr-1" variant="success" @click="emitirGuia(passo, indicePassos)"
                  ><i class="fas fa-check"></i>Emitir Guia</b-button>
                <b-button class="mr-1" variant="secondary"  @click="limparPasso(passo, indicePassos)"
                  ><i class="fas fa-eraser"></i>Limpar</b-button>
                <b-button class="mr-1" variant="primary"  @click="novaEmissao()"
                  >Nova GR-PR</b-button>
            </div>
          </div>          
        </b-card>
        </div>
    </b-overlay>
    <div class="text-center" v-show="carregando">
      <b-spinner variant="primary"></b-spinner>
      <p><b>{{tituloOverlay}}</b></p>
    </div>
    </b-card>
    <b-card id="card_guia" v-else-if="renderizar && controleTela.valor == controleTela.EXIBIR_GUIA" style="min-height:100%">
      <div slot="header">Guia de Recolhimento do Estado do Paraná</div>
        <iframe
          frameborder="0"
          width="100%"
          height="1050"
          :src="linkDaGuia"
          >
        </iframe>
    </b-card>
    <b-card v-else>
      <b-alert show variant="danger" >Formulário inexistente.</b-alert>
    </b-card>
    <a ref="linkRedirecionamento" v-show="false" target="_blank"></a>
  </div>
</template>

<script>
import EmitirGuiaPasso1 from './EmitirGuiaPasso1.vue'
import InputTipoDado from './InputTipoDado'
import { grprService } from '@/api/grpr-service'
import { emissaoGrprService } from '@/api/emissaogrpr-service'
import mixinOverlay from '@/mixins/overlay.js'
import messageBoxM from '@/mixins/messageBoxMixin.js'
import _ from 'lodash'
import store from '@/store'
// import { FormWizard, TabContent } from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  components: {
    EmitirGuiaPasso1,
    InputTipoDado
    // FormWizard,
    // TabContent
  },
  mixins: [mixinOverlay, messageBoxM],
  data () {
    return {
      tamanhoLargura: 0,
      passos: [],
      controlePassos: {
        passoAtual : 0,
        totalPassos: 0,
      },
      disabledConsultaInicial: false,
      renderizar: true,
      copiaPassoAtual: '',
      isPassoDesabilitado: false,
      linkDaGuia: '',
      controleTela: {
        valor: 1,
        EXIBIR_PASSOS: 1,
        EXIBIR_GUIA: 2
      },
      reCaptchaKey: window.location.hostname.includes("arrecadacao.fazenda.pr.gov.br") || window.location.hostname.includes("emitirgrpr.sefa.pr.gov.br") ? '6LeuzLspAAAAAF0LbB_B8eW66gTwxfTgpm7-_6IQ' : '6LeYVhEnAAAAAKwXThPK728k_3meLp564_xRkApM',
    }
  },
  async mounted() {
    this.$v.$reset();
  },
  computed: {
    habilitaNovaConsulta () {
      return (this.passos.length && Object.keys(this.passos[0].data).length) ? true : false
    },
    isAutenticado() {
      return this.$route.meta.requiresAuth
    },
    exibirMensagemIPVA() {
      if (!(this.passos.length > 0 && this.passos[0].data && this.passos[0].data.cdCategoria == 2)) {
        return false
      }
      
      const agora = new Date()
      const inicioPeriodo = new Date('2025-12-29T00:00:00')
      const fimPeriodo = new Date('2026-01-01T15:00:00')
      
      return agora >= inicioPeriodo && agora <= fimPeriodo
    }
    /* ,
    passoAtualInvalido () {
      return (this.$v?.$invalid || false)
    } */
  },
methods: {
     async avancar(passo, indice) {
      store.dispatch('message/resetMessages')
      //this.$v.passos.$each[indice].data.lstCampos.$touch()

      /*if(this.$v.passos.$each[indice].data.lstCampos.$pending) {
        this.desabilitarPasso(passo, true)
        this.setMesagemCarregando('Validando formulário.')
        await this.esperarValidacao(indice)
      }

      if(this.$v.passos.$each[indice].data.lstCampos.$invalid) {
        this.desabilitarPasso(passo, false)
        this.resetCarregando()
        return true
      }*/
      
      this.desabilitarPasso(passo, true)
      this.setMesagemCarregando('Carregando a próxima etapa.')

      try {
        await this.retirarListaDeErros(passo.data)
        let _passo = await this.retirarListasParaEnvio(_.cloneDeep(passo.data))
        _passo.passoAtual = indice + 1

        if(!this.isAutenticado) {
            // reCAPTCHA Enterprise
            _passo.reCaptchaToken = await grecaptcha.enterprise.execute(this.reCaptchaKey, {
              action: 'emissao_guia'
            });
        } else {
          _passo.reCaptchaToken = ''
        }

        let novoPasso = await emissaoGrprService.consultarInformacoesEmissao(_passo)

        // Tratar o redirecionamento.
        if(novoPasso.data.redirecionar == true) {
          this.resetCarregando()

          const redirecionamento = {
            redirecionamento: novoPasso.data.redirecionamento,
            redirecionar: novoPasso.data.redirecionar
          }
          await this.abrirRedirecionamento(redirecionamento)

          this.desabilitarPasso(passo, false)
          return false
        }


        if(novoPasso?.data?.temErro === true) {
          await this.copiarListaDeErros(passo.data, novoPasso.data)
          this.desabilitarPasso(passo, false)
        }

        if(novoPasso?.data?.lstErros?.length  > 0) {
          this.desabilitarPasso(passo, false)
          let listaFormatada = {errors: novoPasso?.data?.lstErros.map((e) => ({code: '', message: e.rmesg}))}
          store.dispatch('message/setMessages', {message: listaFormatada, variant: 'danger'})
          return false
        }

        if(novoPasso?.data?.temErro === false) {
          let copia = _.cloneDeep(novoPasso.data)
          copia.lstCampos = []
          
          _.cloneDeep(this.passos[indice].data).lstCampos
          .forEach((e) => {
            copia.lstCampos.push(e)
          })
          _.cloneDeep(novoPasso.data).lstCampos
          .forEach((e) => {
            if(e.passo == indice + 2) {
              e.valor=''
              copia.lstCampos.push(e)
            }
          })

          this.passos[novoPasso.data.passoAtual - 1].data = _.cloneDeep(copia) //_.cloneDeep(novoPasso.data)

          this.copiaPassoAtual = _.cloneDeep(this.passos[novoPasso.data.passoAtual - 1].data)
          this.copiaPassoAtual.lstItem = []
          this.controlePassos.passoAtual = novoPasso.data.passoAtual
        
          if(this.copiaPassoAtual?.temAviso === true) {
            let listaFormatada = {errors: this.copiaPassoAtual?.lstAvisos.map((e) => ({code: '', message: e.mensagem}))}
            store.dispatch('message/setMessages', {message: listaFormatada, variant: 'warning'})
          } else {
            this.posicionarCard(indice + 1)
          }
                    
        }
      } catch(e) {        
        this.desabilitarPasso(passo, false)
        store.dispatch('message/setMessages', {message: 'Ocorreu um erro inesperado. Por favor, tente mais tarde.', variant: 'danger'})
      } finally {        
        this.resetCarregando()
      }

    },
    limparPasso(passo, indice) {
      store.dispatch('message/resetMessages')
      this.$v.passos.$each[indice].$reset()

      if(passo.data.passoAtual == null)
        passo.data.passoAtual = 1

      if(passo.data.passoAtual - 1 == 0) {
        this.disabledConsultaInicial = false
      }

      for(let i = indice; i < this.controlePassos.totalPassos; i++) {
        this.passos[i].data = {}
        this.passos[i].disabled = false

      }
      this.controlePassos.passoAtual = indice
      if(indice > 0) {       
        this.copiaPassoAtual = _.cloneDeep(this.passos[indice - 1].data)
        this.copiaPassoAtual.lstItem = []
        this.passos[indice - 1].disabled = false
      }

    },
    async emitirGuia(passo, indice) {
      this.retirarListaDeErros(passo.data)
      store.dispatch('message/resetMessages')
      //this.$v.passos.$each[indice].data.lstCampos.$touch()

      /*if(this.$v.passos.$each[indice].data.lstCampos.$pending) {
        this.desabilitarPasso(passo, true)
        this.setMesagemCarregando('Validando formulário.')
        await this.esperarValidacao(indice)
      }

      if(this.$v.passos.$each[indice].data.lstCampos.$invalid) {
        this.desabilitarPasso(passo, false)
        this.resetCarregando()
        return true
      }*/
      
      this.setMesagemCarregando('Emitindo Guia.')
      try {
        let _passo = await this.retirarListasParaEnvio(_.cloneDeep(passo.data))
        _passo.passoAtual = indice + 1


        if(!this.isAutenticado) {
            // reCAPTCHA Enterprise
            _passo.reCaptchaToken = await grecaptcha.enterprise.execute(this.reCaptchaKey, {
            action: 'emissao_guia'
        });
        } else {
            _passo.reCaptchaToken = ''
        }

        let guia = await emissaoGrprService.emitir(_passo)

        if(guia?.data?.temErro === true) {

          if(guia?.data?.lstErros?.length  > 0) {
            await this.copiarListaDeErros(passo.data, guia.data)
            this.desabilitarPasso(passo, false)
            let listaFormatada = {errors: guia?.data?.lstErros.map((e) => ({code: '', message: e.rmesg}))}
            store.dispatch('message/setMessages', {message: listaFormatada, variant: 'danger'})          
          }

          return false
        }

        if(guia.data?.espelho?.cdBarras) {          
          this.exibirPaginaGuiaPorCdBarras(guia.data?.espelho?.cdBarras)
          this.posicionarCard('guia')
          return false          
        }

        throw new Error({descricao: 'Não foi possível emitir a guia.', variant: 'danger'})

      } catch(e) {
          this.desabilitarPasso(passo, false)
          store.dispatch('message/setMessages', {message: 'Ocorreu um erro inesperado. Por favor, tente mais tarde.', variant: 'danger'})
      } finally {
        this.desabilitarPasso(passo, false)
        this.resetCarregando()
      }

    },
    desabilitarPasso(passo, desabilita) {
      passo.disabled = desabilita
    },
    async carregarPasso1(parms) {
      try {
        store.dispatch('message/resetMessages')
        this.disabledConsultaInicial = true
        this.setMesagemCarregando('Carregando a próxima etapa.')
        let passoInicial = (await emissaoGrprService.buscarCampos(parms)).data
        
        // Tratar o redirecionamento.
        if(passoInicial.redirecionamento != null) {
          this.resetCarregando()

          const redirecionamento = {
            redirecionamento: passoInicial.redirecionamento,
            redirecionar: passoInicial.redirecionar
          }
          await this.abrirRedirecionamento(redirecionamento)

          this.disabledConsultaInicial = false
          return false
        }

        if(passoInicial?.temErro === true) {
          let listaFormatada = {errors: passoInicial?.lstErros.map((e) => ({code: '', message: e.rmesg}))}
          store.dispatch('message/setMessages', {message: listaFormatada, variant: 'danger'})
          this.disabledConsultaInicial = false
          this.resetCarregando()
          return false
        }

        if(passoInicial?.temAviso === true) {
          let listaFormatada = {errors: passoInicial?.lstAvisos.map((e) => ({code: '', message: e.mensagem}))}
          store.dispatch('message/setMessages', {message: listaFormatada, variant: 'warning'})
        }

        this.passos = []
        this.carregarPassos(passoInicial)
        this.posicionarCard(this.controlePassos.passoAtual - 1)
        this.$v.passos.$each[0].$reset()
      } catch(e) {
        this.disabledConsultaInicial = false
      } finally {
        this.resetCarregando()
      }
    },
    criarPassoVazio() {
      return  {
          data: {},
          disabled: false
      }
    },
    carregarPassos(passoInicial) {
      if((passoInicial != null) && (passoInicial != undefined)) {
        this.copiaPassoAtual = _.cloneDeep(passoInicial)      
        this.controlePassos.passoAtual = passoInicial.passoAtual
        this.controlePassos.totalPassos = passoInicial.totalPassos

        let passo1 = this.criarPassoVazio()
        passo1.data = passoInicial
        this.passos.push(passo1)
        
        for(let i = 1; i < passoInicial.totalPassos; i++) {
          this.passos.push(this.criarPassoVazio())
        }
      }
    },
    novaEmissao() {      
      this.passos = []
      this.disabledConsultaInicial = false
      this.controlePassos = {
        passoAtual : 0,
        totalPassos: 0,
      }
      this.copiaPassoAtual = ''
      this.$v.$reset()

      // this.$refs.passoInicial.novaEmissao()
    },
    exibirPaginaGuiaPorCdBarras(cdBarras) {
        this.linkDaGuia = `/arrecadacao/api/v1/emissao-grpr/html/${cdBarras}`
        this.controleTela.valor = this.controleTela.EXIBIR_GUIA
    },
    posicionarCard(posicao) {          
      this.$nextTick(() => {
        const element = document.getElementById('card_'+ posicao);
        if (element) {
          const yOffset = -100; // Header (75px) + margem
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }
      })
    },
    async retirarListaDeErros(passo) {
      passo.lstCampos.forEach(element => {
        element.lstErros = []
      });
    },
    async retirarListasParaEnvio(passo) {
      passo.lstCampos.forEach(element => {
        if(element.lista)          
          element.lstItem = []
      });

      return passo
    },
    situacaoInexistente() {
      this.renderizar = false
    },
    async copiarListaDeErros(passo, listaDeErros) {
      let _listaDeErros

      passo.lstCampos.forEach((elementoPasso) => {
        _listaDeErros = listaDeErros.lstCampos.find((elementoErro) => (elementoPasso.idParametCampoGuia == elementoErro.idParametCampoGuia))
        elementoPasso.lstErros = (_listaDeErros?.lstErros) ? _listaDeErros?.lstErros : null
      })
    },
   async esperarValidacao(indice) {
      return new Promise((resolve) => {
          const unwatch = this.$watch(() => (!this.$v.passos.$each[indice].$pending),
            function (value) {
              if(value) {
                unwatch()
                resolve()                
              }
            }, {immediate: true}
          )
      })
    },
    campoTemPai(lista, campo) {
      let tamanho = lista.filter((e) => (e.idParametCampoGuiaCruzada == campo.idParametCampoGuia)).length
      return tamanho > 0
    },
    calculaLargura(lista, i) {
      let tamanhoLista = lista.length      
      if((tamanhoLista > 1) && (i < tamanhoLista - 1)) {
        if((lista[i].indMontagem == 2) || (lista[i + 1].indMontagem == 2))
          return 6
        else
          return 12
      }
      return (lista[i].indMontagem == 2) ? 6 : 12
    },
    calculaLarguraInterna(lista, i) {
      return (this.calculaLargura(lista, i) == 6) ? 12 : 6
    },
    async abrirRedirecionamento(redirecionamento) {
        let resposta = await this.getMsgBoxRedirecionamento(redirecionamento)
        if(resposta) {
          this.$refs.linkRedirecionamento.href = redirecionamento.redirecionamento.linkRedirecionamento
          this.$refs.linkRedirecionamento.click()
        }
    }
  },
  validations: {
    passos: {
      $each: {
        data: {
          lstCampos: {
            $each: {
              // validador de valor obrigatorio
              obrigatorio: function(value) {
                if((value == null) || (value == undefined)) {
                  return true
                }
              
                value.lstErros = []

                if( (!value.editavel && value.cdCampoGuia != 13) || this.controlePassos.passoAtual != value.passo || !value.obrigatorio || value.visivelPadrao == false)
                  return true

                if(!value.valorFormatado) {
                    value.lstErros = [{ rcode: -9905, rmesg: value.msgObrigatorio }]
                    return false
                }

                if(value.tpDado == 2 && value.obrigatorio && value.valorFormatado == 0.0) {
                    value.lstErros = [{ rcode: -9905, rmesg: value.msgObrigatorio }]
                    return false
                }

                let campo = (value.valorFormatado) ? value.valorFormatado : ''

                if(value.tpDado == 4) {
                  campo = campo.replace(/\D+/g, '')
                }

                return true
              },

              // validador de valor decimal maior que zero
              maiorQueZero: function(value) {
                if((value == null) || (value == undefined)) {
                  return true
                }
                
                if(!value.obrigatorio && (value.valorFormatado == '' || value.valorFormatado == null)) {
                  return true
                }
                
                if((!value.editavel && value.cdCampoGuia != 13) || value.lstErros.length || this.controlePassos.passoAtual != value.passo || value.visivelPadrao == false)
                  return true

                if(value.maiorQueZero == true && value.valorFormatado <= 0 && value.obrigatorio)
                  return value.lstErros = [{ rcode: -9906, rmesg: 'O valor deve ser maior que 0' }]
                
                
                return true
              },

              // valor minimo de caracteres
              valorMinimo: function(value) {
                if((value == null) || (value == undefined)) {
                  return true
                }
                
                if(!value.obrigatorio && (value.valorFormatado == '' || value.valorFormatado == null)) {
                  return true
                }

                if((!value.editavel && value.cdCampoGuia != 13) || value.lstErros.length || this.controlePassos.passoAtual != value.passo || value.tamMinimo == null || value.visivelPadrao == false) {
                  return true
                }

                if(value.tpDado == 1) {
                  let campo = (''+value.valorFormatado).replace(/\D+/g, '')

                  if(campo.length === value.tamanhoFixo)
                    return true

                  if(campo.length < value.tamMinimo) {
                    value.lstErros = [{ rcode: -9901, rmesg: value.msgTamMinimo }]
                    return false
                  }

                  return true
                }

                if(value.tpDado == 3) {
                  let campo = (''+value.valorFormatado).replace(/[^0-9a-zA-Z]+/g, '')

                  if(campo.length === value.tamanhoFixo)
                    return true

                  if(campo.length < value.tamMinimo) {
                    value.lstErros = [{ rcode: -9902, rmesg: value.msgTamMinimo }]
                    return false
                  }

                  return true
                }

                return true;
              },

              // valor maximo de caracteres
              valorMaximo: function(value) {
                if((value == null) || (value == undefined)) {
                  return true
                }
                
                if(!value.obrigatorio && (value.valorFormatado == '' || value.valorFormatado == null)) {
                  return true
                }
                
                if((!value.editavel && value.cdCampoGuia != 13) || value.lstErros.length || this.controlePassos.passoAtual != value.passo || value.tamMaximo == null || value.visivelPadrao == false)
                  return true

                if(value.tpDado == 1) {
                  let campo = (''+value.valorFormatado).replace(/\D+/g, '')

                  if(campo.length === value.tamanhoFixo)
                    return true

                  if(campo.length > value.tamMaximo) {
                    value.lstErros = [{ rcode: -9903, rmesg: value.msgTamMinimo }]
                    return false
                  }

                  return true
                }

                if(value.tpDado == 3) {
                  let campo = (''+value.valorFormatado).replace(/[^0-9a-zA-Z]+/g, '')

                  if(campo.length === value.tamanhoFixo)
                    return true

                  if(campo.length > value.tamMaximo) {
                    value.lstErros = [{ rcode: -9904, rmesg: value.msgTamMaximo }]
                    return false
                  }

                  return true
                }

                return true
              },

              // Se passar pelo front-end, então chama o validador no back-end.
              validacaoBackEnd: async function (value) {
                if((value == null) || (value == undefined)) {
                  return true
                }
                
                if(!value.obrigatorio && (value.valorFormatado == '' || value.valorFormatado == null)) {
                  return true
                }

                if((!value.editavel && value.cdCampoGuia != 13) || value.lstErros.length || this.controlePassos.passoAtual != value.passo || value.visivelPadrao == false) {
                  return true
                }
  
                //let p = _.cloneDeep(this.copiaPassoAtual)
                //p.lstCampos = [_.cloneDeep(value)]                
                //p.lstCampos[0].lstItem = []
     
                // Para validacao de campos dependentes
                let p = _.cloneDeep(this.passos[this.controlePassos.passoAtual - 1].data)
                p.idParametCampoGuiaParaValidar = value.idParametCampoGuia
                p.lstCampos.forEach((e) => {
                  e.lstItem = []
                })

                try {
                  let retorno = await emissaoGrprService.validarEmissao(p)
                  
                  if(retorno.data.temErro) {
                      value.lstErros = retorno.data.lstErros
                      return false
                  }
                  return true
                } catch(e) {
                    value.lstErros = [{ rcode: -999999, rmesg: 'Erro ao validar campo.' }]                    
                }
                return false

              }
            }
          }
        }
      }
    }
  }
}
</script>

<style>
</style>
